import { Component, EventEmitter, inject, Input, Output, ViewChild } from '@angular/core';
import { CrudEditComponent } from '../../../shared/components/crud/edit/edit.component';
import { CompetenciasService } from '../../../core/competencia.service';
import { NivelService } from '../../../core/nivel.service';
import { TituloService } from '../../../core/titulo.service';
import { MateriasService } from '../../../core/materias.service';
import { CaracterService } from '../../../core/caracter.service';
import { ModalidadService } from '../../../core/modalidad.service';
import { COMPETENCIAS_FIELDS_CONFIG } from '../../../constants/competencias.constants';
import { defaultPaginateSelects } from '../../../utils/paginate.utils';
import { CompetenciaInterface } from '../../../models/competencia.model';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AlertComponent } from '../../../shared/components/alert/alert.component';

@Component({
  selector: 'app-competencias-edit',
  imports: [CrudEditComponent,MatProgressSpinnerModule],
  templateUrl: './edit.component.html',
  styleUrl: './edit.component.scss'
})
export class CompetenciasEditComponent {
  @Input() id !: number;
  apiService = inject(CompetenciasService);
  nivelService = inject(NivelService);
  tituloService = inject(TituloService);
  materiaService = inject(MateriasService);
  caracterService = inject(CaracterService);
  modalidadService = inject(ModalidadService);
  competenciaService = inject(CompetenciasService);
  private alert = inject(AlertComponent);
  fields = COMPETENCIAS_FIELDS_CONFIG;
  nivel?:number;
  competencia !: CompetenciaInterface;
  @Output() formSubmitEvent = new EventEmitter<any>();
  @ViewChild('editCompetencia') editCompetencia !: CrudEditComponent<CompetenciaInterface>;
  ngOnInit() {
    this.apiService.getById(Number(this.id)).subscribe((data) => {
        this.competencia = data as CompetenciaInterface;
        this.nivel = this.competencia.nivel_id;
        this.getDataForSelects(this.nivel);
      });
  }
  filterSelectsByNivel(select: {field: string, value: number}) {
    if(select.field !== 'nivel_id') return;
    this.fields['caracter_id'].options = [];
    this.editCompetencia.clearField('caracter_id');
    this.editCompetencia.clearField('modalidad_id');
    this.getDataForSelects(select.value);
  }
  getDataForSelects(nivel:number){
    const paginateOptions = { ...defaultPaginateSelects, mainFilterField: "nivel_id", mainValueToFilter: nivel };
    this.caracterService.getAllForSelect(paginateOptions).subscribe((data: any) => {
      this.fields['caracter_id'].options = data;
    });
    this.modalidadService.getAllForSelect(paginateOptions).subscribe((data: any) => {
      this.fields['modalidad_id'].options = data;
    });
  }
  submit() {
    const submitForm = this.editCompetencia.form.onSubmit();
    if (submitForm) {
      this.apiService.update(submitForm, Number(this.id)).subscribe({
        next: data => {
          this.alert.goBack = false; // Evitar que el alert haga un "go back" al cerrar
          this.alert.emitEventOnClose = true; // Configurar para emitir evento al cerrar el alert
          this.alert.returnFocus = false; // Evitar que el alert intente devolver el foco a un elemento específico
          this.alert.openAlert("success", "Guardado!");
          this.apiService.clearCache();
          this.formSubmitEvent.emit(data);
        },
        error: err => {
          this.alert.openAlert("error", "Algo ocurrió");
        }
      });
    }
  }

}
